const sleep = (t: number) => new Promise(resolve => setTimeout(resolve, t));

export {
  sleep,
};
